export const ROLE_GRADES_ASC = [
  "S1",
  "S2",
  "A0",
  "A1",
  "A2",
  "A3",
  "A4",
  "M1A",
  "M1B",
  "M2A",
  "M2B",
  "E1A",
  "E1B",
  "E2A",
  "E2B",
  "L1",
  "L2",
  "L3",
];

export const FUNCTIONS = [
  "ENG",
  "CRT",
  "DEL",
  "SLS",
  "MKT",
  "HRM",
  "FIN",
  "INF",
];

export function getHigherRoleNamesAcrossFunctions(currentRoleName) {
  if (!currentRoleName || typeof currentRoleName !== "string") return [];
  const parts = currentRoleName.split("-");
  if (parts.length < 2) return [];
  const grade = parts[1];
  const idx = ROLE_GRADES_ASC.indexOf(grade);
  if (idx === -1) return [];
  const higherGrades = ROLE_GRADES_ASC.slice(idx + 1);
  return FUNCTIONS.flatMap((fn) => higherGrades.map((g) => `${fn}-${g}`));
}

// Returns an array of grade codes higher than the grade parsed from role name.
// Example: "DEL-A2" -> ["A3", "A4", ..., "L3"]
export function getHigherGradesFromRoleName(currentRoleName) {
  if (!currentRoleName || typeof currentRoleName !== "string") return [];
  const parts = currentRoleName.split("-");
  if (parts.length < 2) return [];
  const grade = parts[1];
  return getHigherGradesFromGrade(grade);
}

// Returns an array of grade codes higher than the provided grade (e.g., "A2")
export function getHigherGradesFromGrade(grade) {
  if (!grade || typeof grade !== "string") return [];
  const idx = ROLE_GRADES_ASC.indexOf(grade);
  if (idx === -1) return [];
  return ROLE_GRADES_ASC.slice(idx + 1);
}
